const Section = (props: { children: React.ReactNode, dark?: boolean, className?: string, innerClassName?: string, noPadding?: boolean }) => (
  <section className={`${props.dark ? "bg-gray-200" : "bg-white"} py-16 ${props.className || ""}`}>
    <div className={"container max-w-screen-lg p-6 " + props.innerClassName || ""}>{props.children}</div>
  </section>
);

export default Section;
